import _classCallCheck from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _get from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _inherits from "C:\\Users\\m.tsaqif\\Desktop\\S-Champions\\sc-webview\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { Factory } from './Factory.js';
import { Node } from './Node.js';
import { getNumberValidator } from './Validators.js';
export var Container =
/*#__PURE__*/
function (_Node) {
  _inherits(Container, _Node);

  function Container() {
    var _this;

    _classCallCheck(this, Container);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Container).apply(this, arguments));
    _this.children = [];
    return _this;
  }

  _createClass(Container, [{
    key: "getChildren",
    value: function getChildren(filterFunc) {
      if (!filterFunc) {
        return this.children || [];
      }

      var children = this.children || [];
      var results = [];
      children.forEach(function (child) {
        if (filterFunc(child)) {
          results.push(child);
        }
      });
      return results;
    }
  }, {
    key: "hasChildren",
    value: function hasChildren() {
      return this.getChildren().length > 0;
    }
  }, {
    key: "removeChildren",
    value: function removeChildren() {
      this.getChildren().forEach(function (child) {
        child.parent = null;
        child.index = 0;
        child.remove();
      });
      this.children = [];

      this._requestDraw();

      return this;
    }
  }, {
    key: "destroyChildren",
    value: function destroyChildren() {
      this.getChildren().forEach(function (child) {
        child.parent = null;
        child.index = 0;
        child.destroy();
      });
      this.children = [];

      this._requestDraw();

      return this;
    }
  }, {
    key: "add",
    value: function add() {
      for (var _len = arguments.length, children = new Array(_len), _key = 0; _key < _len; _key++) {
        children[_key] = arguments[_key];
      }

      if (arguments.length > 1) {
        for (var i = 0; i < arguments.length; i++) {
          this.add(arguments[i]);
        }

        return this;
      }

      var child = children[0];

      if (child.getParent()) {
        child.moveTo(this);
        return this;
      }

      this._validateAdd(child);

      child.index = this.getChildren().length;
      child.parent = this;

      child._clearCaches();

      this.getChildren().push(child);

      this._fire('add', {
        child: child
      });

      this._requestDraw();

      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.hasChildren()) {
        this.destroyChildren();
      }

      _get(_getPrototypeOf(Container.prototype), "destroy", this).call(this);

      return this;
    }
  }, {
    key: "find",
    value: function find(selector) {
      return this._generalFind(selector, false);
    }
  }, {
    key: "findOne",
    value: function findOne(selector) {
      var result = this._generalFind(selector, true);

      return result.length > 0 ? result[0] : undefined;
    }
  }, {
    key: "_generalFind",
    value: function _generalFind(selector, findOne) {
      var retArr = [];

      this._descendants(function (node) {
        var valid = node._isMatch(selector);

        if (valid) {
          retArr.push(node);
        }

        if (valid && findOne) {
          return true;
        }

        return false;
      });

      return retArr;
    }
  }, {
    key: "_descendants",
    value: function _descendants(fn) {
      var shouldStop = false;
      var children = this.getChildren();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var child = _step.value;
          shouldStop = fn(child);

          if (shouldStop) {
            return true;
          }

          if (!child.hasChildren()) {
            continue;
          }

          shouldStop = child._descendants(fn);

          if (shouldStop) {
            return true;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  }, {
    key: "toObject",
    value: function toObject() {
      var obj = Node.prototype.toObject.call(this);
      obj.children = [];
      this.getChildren().forEach(function (child) {
        obj.children.push(child.toObject());
      });
      return obj;
    }
  }, {
    key: "isAncestorOf",
    value: function isAncestorOf(node) {
      var parent = node.getParent();

      while (parent) {
        if (parent._id === this._id) {
          return true;
        }

        parent = parent.getParent();
      }

      return false;
    }
  }, {
    key: "clone",
    value: function clone(obj) {
      var node = Node.prototype.clone.call(this, obj);
      this.getChildren().forEach(function (no) {
        node.add(no.clone());
      });
      return node;
    }
  }, {
    key: "getAllIntersections",
    value: function getAllIntersections(pos) {
      var arr = [];
      this.find('Shape').forEach(function (shape) {
        if (shape.isVisible() && shape.intersects(pos)) {
          arr.push(shape);
        }
      });
      return arr;
    }
  }, {
    key: "_clearSelfAndDescendantCache",
    value: function _clearSelfAndDescendantCache(attr) {
      var _a;

      _get(_getPrototypeOf(Container.prototype), "_clearSelfAndDescendantCache", this).call(this, attr);

      if (this.isCached()) {
        return;
      }

      (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (node) {
        node._clearSelfAndDescendantCache(attr);
      });
    }
  }, {
    key: "_setChildrenIndices",
    value: function _setChildrenIndices() {
      var _a;

      (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child, n) {
        child.index = n;
      });

      this._requestDraw();
    }
  }, {
    key: "drawScene",
    value: function drawScene(can, top) {
      var layer = this.getLayer(),
          canvas = can || layer && layer.getCanvas(),
          context = canvas && canvas.getContext(),
          cachedCanvas = this._getCanvasCache(),
          cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;

      var caching = canvas && canvas.isCache;

      if (!this.isVisible() && !caching) {
        return this;
      }

      if (cachedSceneCanvas) {
        context.save();
        var m = this.getAbsoluteTransform(top).getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);

        this._drawCachedSceneCanvas(context);

        context.restore();
      } else {
        this._drawChildren('drawScene', canvas, top);
      }

      return this;
    }
  }, {
    key: "drawHit",
    value: function drawHit(can, top) {
      if (!this.shouldDrawHit(top)) {
        return this;
      }

      var layer = this.getLayer(),
          canvas = can || layer && layer.hitCanvas,
          context = canvas && canvas.getContext(),
          cachedCanvas = this._getCanvasCache(),
          cachedHitCanvas = cachedCanvas && cachedCanvas.hit;

      if (cachedHitCanvas) {
        context.save();
        var m = this.getAbsoluteTransform(top).getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);

        this._drawCachedHitCanvas(context);

        context.restore();
      } else {
        this._drawChildren('drawHit', canvas, top);
      }

      return this;
    }
  }, {
    key: "_drawChildren",
    value: function _drawChildren(drawMethod, canvas, top) {
      var _a;

      var context = canvas && canvas.getContext(),
          clipWidth = this.clipWidth(),
          clipHeight = this.clipHeight(),
          clipFunc = this.clipFunc(),
          hasClip = clipWidth && clipHeight || clipFunc;
      var selfCache = top === this;

      if (hasClip) {
        context.save();
        var transform = this.getAbsoluteTransform(top);
        var m = transform.getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        context.beginPath();

        if (clipFunc) {
          clipFunc.call(this, context, this);
        } else {
          var clipX = this.clipX();
          var clipY = this.clipY();
          context.rect(clipX, clipY, clipWidth, clipHeight);
        }

        context.clip();
        m = transform.copy().invert().getMatrix();
        context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }

      var hasComposition = !selfCache && this.globalCompositeOperation() !== 'source-over' && drawMethod === 'drawScene';

      if (hasComposition) {
        context.save();

        context._applyGlobalCompositeOperation(this);
      }

      (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
        child[drawMethod](canvas, top);
      });

      if (hasComposition) {
        context.restore();
      }

      if (hasClip) {
        context.restore();
      }
    }
  }, {
    key: "getClientRect",
    value: function getClientRect(config) {
      var _a;

      config = config || {};
      var skipTransform = config.skipTransform;
      var relativeTo = config.relativeTo;
      var minX, minY, maxX, maxY;
      var selfRect = {
        x: Infinity,
        y: Infinity,
        width: 0,
        height: 0
      };
      var that = this;
      (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (child) {
        if (!child.visible()) {
          return;
        }

        var rect = child.getClientRect({
          relativeTo: that,
          skipShadow: config.skipShadow,
          skipStroke: config.skipStroke
        });

        if (rect.width === 0 && rect.height === 0) {
          return;
        }

        if (minX === undefined) {
          minX = rect.x;
          minY = rect.y;
          maxX = rect.x + rect.width;
          maxY = rect.y + rect.height;
        } else {
          minX = Math.min(minX, rect.x);
          minY = Math.min(minY, rect.y);
          maxX = Math.max(maxX, rect.x + rect.width);
          maxY = Math.max(maxY, rect.y + rect.height);
        }
      });
      var shapes = this.find('Shape');
      var hasVisible = false;

      for (var i = 0; i < shapes.length; i++) {
        var shape = shapes[i];

        if (shape._isVisible(this)) {
          hasVisible = true;
          break;
        }
      }

      if (hasVisible && minX !== undefined) {
        selfRect = {
          x: minX,
          y: minY,
          width: maxX - minX,
          height: maxY - minY
        };
      } else {
        selfRect = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }

      if (!skipTransform) {
        return this._transformedRect(selfRect, relativeTo);
      }

      return selfRect;
    }
  }]);

  return Container;
}(Node);
Factory.addComponentsGetterSetter(Container, 'clip', ['x', 'y', 'width', 'height']);
Factory.addGetterSetter(Container, 'clipX', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipY', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipWidth', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipHeight', undefined, getNumberValidator());
Factory.addGetterSetter(Container, 'clipFunc');